<template>
  <div class="row">
    <div class="col-12">
      <header class="custom-header-one d-flex justify-content-between" v-bind:style="{color : this.settings_style.colors != undefined ? this.settings_style.colors[5].color_value : 'white'}">
        <img class="company-logo align-self-end" v-if="this.settings_style.logo != ''" v-bind:src="(this.settings_style.logo != null && this.settings_style.logo != undefined && this.settings_style.logo != 'null') ? this.settings_style.logo : this.image_white" alt />
        <div class="ml-auto">
          <div class="folio-wrapper pt-5 pr-5 pb-4 pl-4" v-if="this.settings_style.view_folio" v-bind:style="{backgroundColor: this.settings_style.colors != undefined ? this.settings_style.colors[0].color_value : 'white'}">
            <span class="folio-label text-white" v-if="quote_data != undefined">#{{quote_data.details.folio}}</span>
            <span class="folio-label text-white" v-else>#FOLIO</span>
          </div>
          <div class="pr-5 mt-3">
            <p v-if="this.settings_style.view_date_send">
              <span v-if="quote_data != undefined">
                <b>Fecha de envío:</b> {{quote_data.details.date_send}}
              </span>
              <span v-else>
                <b>Fecha de envío:</b> 24/Diciembre/2018
              </span>
            </p>
            <p v-if="this.settings_style.view_date_validity">
              <span v-if="quote_data != undefined">
                <b>Validez:</b> {{quote_data.details.date_valid}}
              </span>
              <span v-else>
                <b>Validez:</b> 24/Enero/2019
              </span>
              
            </p>
            <p v-if="this.settings_style.view_currency">
              <span v-if="quote_data != undefined">
                <b>Moneda:</b> {{quote_data.details.currency}}
              </span>
              <span v-else>
                <b>Moneda:</b> Moneda Mexicana
              </span>
            </p>
          </div>
        </div>
      </header>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    settings_style: {
      required: true,
    },
    quote_data:{
      type:Object
    }
  },
  data(){
    return{
      image_white : null
    }
  },
  mounted(){
    this.image_white =  require("@/assets/images/white_default.jpg")
  }
}
</script>